import { makeAutoObservable, action, computed, toJS, extendObservable, set } from 'mobx';
import domainData from 'store/domainStore';
import tableOptions from 'pages/wineLabels/config/config';
import { getInitialParams, saveParamsToStorage } from './common/filterUtils';

const STORAGE_KEY = 'wine_label_filter_params';

const defaultData = {};

// Default filter parameters
const defaultFilterParams = {
  params: {
    sort: {
      field: 'createdAt',
      order: 'desc',
    },
    filter: {},
    limit: 50,
    skip: 0,
    search: {
      value: '',
      fields: [],
    },
  },
};

const requiredFields = [];

class WineLabels {
  getDefaultStoreProps = () => ({
    wineLabels: {
      count: 0,
      data: [],
    },
    filterData: defaultFilterParams,
    wineLabelData: JSON.parse(JSON.stringify(defaultData)),
    wineLabelDataErrors: {},
  });

  constructor() {
    makeAutoObservable(this);
    extendObservable(this, { ...this.getDefaultStoreProps() });
  }

  @action
  reset() {
    set(this, this.getDefaultStoreProps());
  }

  @action
  setStoreWineLabels(newData) {
    this.wineLabels.data = [];
    newData.data.forEach(this.addStoreWineLabel);
    this.wineLabels.count = newData.count;
  }

  @action
  addStoreWineLabel = element => {
    this.wineLabels.data.push(element);
  };

  @action
  setFilter(filter) {
    this.filterData = filter;
    // Save to localStorage using common utility, but exclude search
    if (filter?.params) {
      const { search: _search, ...paramsWithoutSearch } = filter.params;
      const filterToSave = {
        ...filter,
        params: paramsWithoutSearch,
      };
      saveParamsToStorage(STORAGE_KEY, filterToSave);
    }
  }

  @action
  resetFilters() {
    this.setFilter(defaultFilterParams);
  }

  // Get current filter parameters using common utility with validation
  getCurrentFilterParams = (urlParams = {}) => {
    const isUserSuperAdmin = domainData.userIsSuperAdmin();
    const subscriptionAccess = domainData.getSubscriptionAllAccess();
    const userContext = { isUserSuperAdmin, subscriptionAccess };

    return getInitialParams(STORAGE_KEY, defaultFilterParams, tableOptions, userContext, urlParams);
  };

  @computed
  get filter() {
    const filterToJS = toJS(this.filterData);
    return filterToJS;
  }

  getWineLabelData = () => this.wineLabelData;

  @action
  setWineLabelData = data => {
    this.wineLabelData = data;
  };

  wineLabelDataHasError = () => {
    let hasError = false;
    requiredFields.forEach(i => {
      if (!this.wineLabelData[i]) {
        this.wineLabelDataErrors[i] = 'required';
        hasError = true;
      } else {
        delete this.wineLabelDataErrors[i];
      }
    });
    return hasError;
  };
}

export default new WineLabels();
